'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = injectStaticInstreamAdContent;

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function handleClickTracking(url) {
  _axios2.default.get(url);
}

function injectStaticInstreamAdContent(divContainer, adContent) {
  var outdatedContent = divContainer.firstChild;
  if (outdatedContent) {
    divContainer.removeChild(outdatedContent);
  }

  /* eslint-disable no-undef */
  var div = document.createElement('div');

  if (adContent.companionClickTracking) {
    div.onclick = function () {
      return handleClickTracking(adContent.companionClickTracking);
    };
  }

  var instreamAdContent = '\n    <a href="' + adContent.companionClickThrough + '" target="_blank" style="display: inline-block">\n      <img src="' + adContent.staticResource + '" width="100%" />\n    </a>\n    <img style="width: 1px; height: 1px; visibility: hidden;" src="' + adContent.trackingPixel + '" />';

  /* eslint-enable no-undef */
  div.innerHTML = instreamAdContent;

  divContainer.appendChild(div);

  return div;
}